// get custom fields data for particular asset
import queryString from 'query-string'; // TODO use native URL api
import getJSON from '@api/api_helper';
import { fetchJson } from '@api/ApiHelper';

import { CustomFieldMapsResponse, CreateCustomFieldParams, CustomFieldValuesListData } from './customFieldTypes';

const fetchMutateUrl = (assetKey): string => `/api/v4/assets/${assetKey}/custom_fields`;

/** @deprecated */
export const getCustomFieldMaps = ({ assetKey }: { assetKey: string }, params = {}): Promise<CustomFieldMapsResponse> => {
  const url = `/api/v4/private/assets/${assetKey}/custom_field_maps`;
  return getJSON(url, { params }, () => { /* no op */ });
};

export const listCustomFieldValues = (
  assetKey: string,
  queryParams: { [key: string]: string }
): Promise<CustomFieldValuesListData> => {
  const query = queryString.stringify(queryParams);
  const appendedQueryString = query ? `?${query}` : '';
  const url = `/api/v4/assets/${assetKey}/custom_field_values${appendedQueryString}`;
  return fetchJson({ url });
};

export const createCustomFields = (
  { assetKey, createdCustomFields }: { assetKey: string; createdCustomFields: CreateCustomFieldParams[]},
  params = {}
): Promise<any> => {
  const url = fetchMutateUrl(assetKey);
  const appendedOptions = {
    body: {
      data: {
        attributes: createdCustomFields
      }
    },
    method: 'POST',
    params
  };
  return getJSON(url, appendedOptions);
};
